<template>
  <div class="w-full space-y-6">
    <div>
      <p
        v-html="$t('page.settings.category.sentencel.enter_keywords-html')"
      />
    </div>

    <multi-select
      v-model="keywords"
      :options="options"
      mode="tags"
      :max="3"
      searchable
      create-tag
      :placeholder="$t('page.settings.category.form.keywords.placeholder')"
      noResultsText=""
      :noOptionsText="$t('page.settings.category.form.category.no_options')"
    />

    <div>
      <a
        href="javascript:void(0)"
        @click.prevent="openInfo"
        class="font-bold text-blue-600"
      >
        {{ $t('page.settings.category.action.keyword.help_message') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onBeforeMount } from 'vue'
import Swal from 'sweetalert2'
import MultiSelect from '@vueform/multiselect'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    MultiSelect,
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  emits: [
    'update:form'
  ],
  setup (props, { emit }) {
    const keywords = ref<string[]>()

    const { t } = useI18n()

    const options = ref<{ value: string; label: string }[]>([])

    watch(keywords, (keywords) => {
      if (keywords) {
        emit('update:form', {
          keywords: Object.values(keywords)
        })
      }
    })

    const openInfo = () => {
      Swal.fire({
        title: t('page.settings.category.action.keyword.help_message'),
        confirmButtonText: t('state.settings.category.about_keywords.action_confirm'),
        html: t('state.settings.category.about_keywords.message-html')
      })
    }

    onBeforeMount(() => {
      if ('keywords' in props.form) {
        keywords.value = Object.values(props.form.keywords)

        options.value = keywords.value.map((k) => {
          return {
            value: k,
            label: k
          }
        })
      }
    })

    return {
      options,
      keywords,
      openInfo
    }
  }
})
</script>
